var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 11.8332L9.99997 8.4999M9.99997 8.4999L6.66663 11.8332M9.99997 8.4999V15.9999M16.9916 13.8249C17.8044 13.3818 18.4465 12.6806 18.8165 11.8321C19.1866 10.9835 19.2635 10.0359 19.0351 9.13881C18.8068 8.2417 18.2862 7.44616 17.5555 6.87778C16.8248 6.30939 15.9257 6.00052 15 5.9999H13.95C13.6977 5.02427 13.2276 4.11852 12.5749 3.35073C11.9222 2.58295 11.104 1.97311 10.1817 1.56708C9.25943 1.16104 8.25709 0.969371 7.25006 1.00647C6.24304 1.04358 5.25752 1.30849 4.36761 1.78129C3.47771 2.2541 2.70656 2.92249 2.11215 3.73622C1.51774 4.54996 1.11554 5.48785 0.935783 6.4794C0.756025 7.47095 0.803388 8.49035 1.07431 9.46095C1.34523 10.4316 1.83267 11.3281 2.49997 12.0832",
    stroke: "#656766",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.a9250558d1045f042b5110df78585287.svg";
export { ForwardRef as ReactComponent };